import line531 from "../../assets/BearishOSSales/Line 531@2x.png";
import line532 from "../../assets/BearishOSSales/Line 532@2x.png";
import line533 from "../../assets/BearishOSSales/Line 533@2x.png";
import line535 from "../../assets/BearishOSSales/Line 535@2x.png";

import back4993 from "../../assets/BearishOSSales/Group 4993@2x.png";
import back4994 from "../../assets/BearishOSSales/Group 4994@2x.png";
import back4995 from "../../assets/BearishOSSales/Group 4995@2x.png";
import back4996 from "../../assets/BearishOSSales/Group 4996@2x.png";

const SalesRatingCardData = [
  {
    percent: "81%",
    linecolor: line535,
    content: "Reported Higher Sales Calls Conversion Rates",
    backgroundimg: back4993,
  },
  {
    percent: "77%",
    linecolor: line531,
    content: "Reported improvement in Customer Follow-Up Efficiency",
    backgroundimg: back4994,
  },
  {
    percent: "62%",
    linecolor: line532,
    content: "Reported an increase in qualified leads",
    backgroundimg: back4995,
  },
  {
    percent: "57%",
    linecolor: line533,
    content: "Reported a reduction in overall sales cycles",
    backgroundimg: back4996,
  },
];
export default SalesRatingCardData;
